import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=41458b80&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=ts&"
export * from "./Navbar.vue?vue&type=script&lang=ts&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=41458b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41458b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serveradmin/azuredevopsagent3/_work/14/s/kbs.frontend/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41458b80')) {
      api.createRecord('41458b80', component.options)
    } else {
      api.reload('41458b80', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=41458b80&scoped=true&", function () {
      api.rerender('41458b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar.vue"
export default component.exports